<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">{{$store.state.themeTitle}}室建设项目管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.applyStatus1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目性质">
          <el-select v-model="formInline.character" clearable filterable placeholder="请选择项目性质">
            <el-option v-for="item in $store.state.characters" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.type" clearable filterable placeholder="请选择类型">
            <el-option v-for="item in $store.state.characterTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建建设项目</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="importUrl" :params="params" btnTitle="导入数据"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="training_name" label="建设项目名称" width="160">
      </custom-table-column>
      <custom-table-column label="审核状态" width="150" prop="status"  :formatter="format_status">
      </custom-table-column>
      <custom-table-column prop="person" label="项目负责人" width="100">
      </custom-table-column>
      <custom-table-column prop="address" label="项目地点" min-width="220">
      </custom-table-column>
      <custom-table-column prop="area" label="使用面积(m²)" width="120">
      </custom-table-column>
      <custom-table-column prop="character_text" label="项目性质" width="120">
        <!-- <template slot-scope="scope">
          <span v-for="item in $store.state.characters" :key="item.value" >{{ scope.row.character==item.value?item.label:'' }}</span>
        </template> -->
      </custom-table-column>
      <custom-table-column prop="type_text" label="项目类型" width="120">
        <!-- <template slot-scope="scope">
          <span v-for="item in $store.state.characterTypes" :key="item.value" >{{ scope.row.type==item.value?item.label:'' }}</span>
        </template> -->
      </custom-table-column>
      <custom-table-column prop="type" label="面向院系专业" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.structure_1 }}-{{ scope.row.major }}</span>
        </template>
      </custom-table-column>
      <custom-table-column prop="investment_num" label="预计投资(万元)" width="150">
      </custom-table-column>
      <custom-table-column prop="start_time" label="开始时间" width="180">
      </custom-table-column>
      <custom-table-column prop="end_time" label="结束时间" width="180">
      </custom-table-column>
      <custom-table-column label="文件" width="150">
        <template slot-scope="scope" v-if="scope.row.annexes">
          <el-link type="primary" v-for="(item,index) in scope.row.annexes.split(',')" :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
        </template>
      </custom-table-column>
      <!-- <custom-table-column prop="desc" label="备注" min-width="200">
      </custom-table-column> -->
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status=='0'" @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <!-- <el-button @click="handleAddItem(scope.row.id)" type="text" size="small">添加条目</el-button> -->
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="建设项目名称" prop="training_name">
          <el-input v-model="ruleForm.training_name" placeholder="请输入建设项目名称" style="width:206px;"></el-input>
        </el-form-item>
        <el-form-item label="项目负责人" prop="person">
          <el-input v-model="ruleForm.person" placeholder="请输入项目负责人" style="width:206px;"></el-input>
        </el-form-item>
        <el-form-item label="项目地点" prop="address">
          <el-input placeholder="请输入项目地点" v-model="ruleForm.address" style="width:542px;"></el-input>
        </el-form-item>
        <el-form-item label="面向院系专业" prop="major">
          <el-input v-model="selectName" placeholder="请选择院系+专业" style="width:542px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="使用面积(m²)" prop="area">
          <el-input v-model.number="ruleForm.area" placeholder="请输入使用面积" style="width:206px;"></el-input>
        </el-form-item>
        <el-form-item label="项目性质" prop="character">
          <el-select v-model="ruleForm.character" clearable filterable placeholder="请选择项目性质" style="width:206px;">
            <el-option v-for="item in $store.state.characters" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目类型" prop="type">
          <el-select v-model="ruleForm.type" clearable filterable placeholder="请选择项目类型" style="width:206px;">
            <el-option v-for="item in $store.state.characterTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预计投资(万元）" prop="investment_num">
          <el-input v-model.number="ruleForm.investment_num" placeholder="请输入预计投资数(万元）" style="width:206px;"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" v-model="ruleForm.start_time" style="width:206px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" v-model="ruleForm.end_time" style="width:206px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="附件" prop="annexes" style="width:100%">
            <Uploadd ref="uploadd" :action="action" :params="params" @setFileList="setUpFileList" @delFile="delUpFile" :btnTitle="btnTitle" :uploadType="uploadType"></Uploadd>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinUpload, mixinOrgan,mixinFormatter,mixinImport],
  data() {
    return {
      props: {
        label: 'name',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        status: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },

      formInline1: {},
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        training_name: '',
        person: '',
        address: '',
        area: '',
        character: '',
        type: '',
        start_time: '',
        end_time: '',
        investment_num: '',
        annexes: '',
        structure_1: '',
        major: '',
      },
      rules: {
        training_name: [{ required: true, message: '请输入建设项目名称', trigger: 'blur' }],
        person: [{ required: true, message: '请输入项目负责人', trigger: 'blur' }],
        address: [{ required: true, message: '请输入项目地点', trigger: 'blur' }],
        character: [{ required: true, message: '请选择项目性质', trigger: 'change' }],
        type: [{ required: true, message: '请选择项目类型', trigger: 'change' }],
        major: [{ required: true, message: '请选择院系+专业' }],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        area: [
          { required: true, message: '面积不能为空' },
          { type: 'number', message: '面积必须为数字值' },
        ],
        investment_num: [
          { required: true, message: '预计投资不能为空' },
          { type: 'number', message: '预计投资必须为数字值' },
        ],
      },
      fileFieldName: 'annexes',
      downloadUrl: 'template/建设项目申请导入模版.xlsx',
      importUrl: '',
    };
  },
  created() {},
  mounted() {
    this.importUrl = `${this.baseUrlt}api/training/room/apply/import`;
    // this.getList();
    // this.$store.dispatch('getStandards');
  },
  watch: {
    eqs: {
      handler: function (val) {
        this.ruleForm.special_equipment = val.join(',');
      },
      deep: false,
    },
    safes: {
      handler: function (val) {
        this.ruleForm.safety_facilities = val.join(',');
      },
      deep: false,
    },
  },
  methods: {
    handleEdit(row, filterArr = ['school_id', 'updated_at', 'created_at']) {
      this.type = 'edit';
      this.title = '编辑';
      if (row.structure_1 && row.major) {
        this.selectName = `${row.structure_1}-${row.major}`;
      }
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.$nextTick(() => {
        if (row.annexes) {
          this.$refs.uploadd.setRefFileList(row.annexes);
        }
      });
      this.centerDialogVisible = true;
    },

    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/training/room/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.uploadd.setRefFileList('');
      });
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/edit`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/room/apply/self/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
    box-shadow: 0 0 1px 1px #ccc;
    padding: 0 8px;
  }
}
</style>
